import { ReactElement } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import PaymentIcon from '@mui/icons-material/Payment';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FlashOnIcon from '@mui/icons-material/FlashOn'; // Instant Buy Icon

export interface NavItemConfig {
  key: string;
  title: string; // Raw string key used for translation in component
  href: string;
  icon: React.ElementType;
  matcher: (pathname: string) => boolean;
  isBottom?: boolean;
}

export const navItems: NavItemConfig[] = [
  {
    key: 'itemInspection',
    title: 'itemInspection',
    href: '/buyer/dashboard/',
    icon: FactCheckIcon,
    matcher: (pathname) => pathname.startsWith('/buyer/dashboard/'),
  },
  {
    key: 'myOrders',
    title: 'myOrders',
    href: '/buyer/dashboard/myorders',
    icon: ShoppingCartIcon,
    matcher: (pathname) => pathname.startsWith('/buyer/dashboard/myorders'),
  },
  {
    key: 'settings',
    title: 'settings',
    href: '/buyer/dashboard/buyersettings',
    icon: SettingsIcon,
    matcher: (pathname) => pathname.startsWith('/buyer/dashboard/buyersettings'),
  },
  {
    key: 'payments',
    title: 'payments',
    href: '/buyer/dashboard/makepayment',
    icon: PaymentIcon,
    matcher: (pathname) => pathname.startsWith('/buyer/dashboard/makepayment'),
  },
   //Add Instant Buy here:
   //{
   //  key: 'instantBuy',
   // title: 'instantBuy',
   // href: '/buyer/dashboard/instantbuy',
   // icon: FlashOnIcon, // Instant Buy Icon
   // matcher: (pathname) => pathname.startsWith('/buyer/dashboard/instantbuy'),
   //},

  // 🔒 Optional items to enable later:
  // {
  //   key: 'parcelTracking',
  //   title: 'parcelTracking',
  //   href: '/buyer/dashboard/parceltracking',
  //   icon: LocalShippingIcon,
  //   matcher: (pathname) => pathname.startsWith('/buyer/dashboard/parceltracking'),
  // },
  // {
  //   key: 'inspectionReport',
  //   title: 'inspectionReport',
  //   href: '/buyer/dashboard/inspectionreport',
  //   icon: AssignmentIcon,
  //   matcher: (pathname) => pathname.startsWith('/buyer/dashboard/inspectionreport'),
  // },
  // {
  //   key: 'confirmDelivery',
  //   title: 'confirmDelivery',
  //   href: '/buyer/dashboard/confirmdelivery',
  //   icon: AssignmentTurnedInIcon,
  //   matcher: (pathname) => pathname.startsWith('/buyer/dashboard/confirmdelivery'),
  // },
  // {
  //   key: 'profile',
  //   title: 'profile',
  //   href: '/buyer/dashboard/buyerprofile',
  //   icon: AccountCircleIcon,
  //   matcher: (pathname) => pathname.startsWith('/buyer/dashboard/buyerprofile'),
  // },
];
